import React, { useEffect, useState } from "react";
import { message, Spin } from "antd";
import EmployeeReportDashboard from "./EmployeeReportDashboard";
import { BookItem } from "utils/employeeReport";
import api from "shared/api/client";

const EmployeeReportPage: React.FC = () => {
  const [books, setBooks] = useState<BookItem[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchBooks = async () => {
    try {
      setLoading(true);

      const res = await api.get("/book/get?page=1&limit=500");
      console.log("FIRST BOOK:", res.data.data?.[0]);
      if (res.data?.success) {
        setBooks(res.data.data || []);
      } else {
        message.error(res.data?.message || "Дата авч чадсангүй");
      }
    } catch (error: any) {
      message.error(error.response?.data?.message || "Серверийн алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return <EmployeeReportDashboard books={books} />;
};

export default EmployeeReportPage;
